<section class="bg-image">
  <div class="mask d-flex align-items-center gradient-custom-3">
    <div class="container contant-height">
      <div class="row d-flex justify-content-center mt-3">
        <div class="col-12 col-md-9 col-lg-7 col-xl-6">
          <div class="text-center mt-5">
            <img src="/assets/logo/chess-logo.svg" alt="">
          </div>
          <div class="card mt-4">
            <div class="card-body">
              <div class="text-center mt-3">
                <img src="assets/main-image/username-page-image-2 (1).png" alt="" class="username-page-image"
                  width="30%">
              </div>

              <form (ngSubmit)="userNameData(userNames.value)" [formGroup]="userNames">

                <div class="">
                  <div class="form-group has-search">
                    <i class="fa fa-user fa-lg fa-fw form-control-feedback" aria-hidden="true" style="color: #000000;"></i>
                    <input type="text" class="form-control" placeholder="create your username" formControlName="username">
                  </div>
                </div>

                <div class="text-center mb-3">
                  <button type="submit" class="btn btn-primary btn-lg sinup-btn" [disabled]="!userNames.valid">Enter</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

